
import React from "react";
import Others from "./others/Others";
import Transactions from "./Transactions";
import Languages from "./others/Languages";
import Countries from "./others/Countries";
import { i18nManager } from "../../../i18n";
import Currencies from "./others/Currencies";
import { Route, Routes } from "react-router-dom";
import Transaction from "./transaction/Transaction";
import { IProfile, ISecondaryData } from "../../../services";
import Configurations from "./configurations/Configurations";
import { DashboardContainer } from "../../shared/DashboardContainer";
import CountryConfigurations from "./configurations/CountryConfigurations";
import ServiceConfigurations from "./configurations/ServiceConfigurations";
import PlatformConfigurations from "./configurations/PlatformConfigurations";
import CountryConfigurationMappings from "./configurations/CountryConfigurationMappings";
import BalanceManagement from "./balance_management/BalanceManagement";

export interface PloutousProps {
    search: string;
    profile: IProfile;
    secondaryData: ISecondaryData;
}

function Ploutous(props: PloutousProps) {
    const labels = i18nManager.Labels.dashboard.ploutous;

    return DashboardContainer({
        ...labels,
        search: props.search,
        secondaryData: props.secondaryData,
        content: (<Routes>
            <Route path="/others" element={<Others/>} />
            <Route path="/others/countries" element={<Countries/>} />
            <Route path="/others/languages" element={<Languages/>} />
            <Route path="/others/currencies" element={<Currencies/>} />
            <Route path="/configurations" element={<Configurations/>} />
            <Route path="/transactions" element={<Transactions profile={props.profile}/>} />
            <Route path="/balance-management" element={<BalanceManagement profile={props.profile}/>} />
            <Route path="/configurations/services/configs" element={<ServiceConfigurations/>} />
            <Route path="/configurations/platform/configs" element={<PlatformConfigurations/>} />
            <Route path="/configurations/countries/configs" element={<CountryConfigurations/>} />
            <Route path="/configurations/countries/mappings" element={<CountryConfigurationMappings/>} />
            <Route path="/transactions/:transactionId" element={<Transaction profile={props.profile}/>} />
        </Routes>),
    });
}

export default Ploutous;
